export const LOAD_LIST_SIGNED_DOCUMENT = 'LOAD_LIST_SIGNED_DOCUMENT';
export const LIST_DOCUMENTS_DOWNLOAD = 'LIST_DOCUMENTS_DOWNLOAD';
export const SET_LOADING = 'SET_LOADING';
export const SET_PLAN_LIST = 'SET_PLAN_LIST';
export const SET_LIST_CERTIFICATES = 'SET_LIST_CERTIFICATES';
export const DOCUMENTS_SIGN = 'DOCUMENTS_SIGN';
export const PENDING_SIGN = 'PENDING_SIGN';
export const PENDING_OBSERVE = 'PENDING_OBSERVE';

